import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap5';
import * as Yup from 'yup';
import {
  Formik,
  Form as FormikForm,
} from 'formik';

import Modal from 'components/new_ui/Modal/Modal';
import HorizontalTextField from 'components/new_ui/Form/HorizontalTextField';
import { useContext } from '../../Context';

export default function Index({ coach, closeEditCoach }) {
  const { actions, dispatch } = useContext();

  const formSchema = Yup.object().shape({
    firstName: Yup.string().required('First Name is required'),
    lastName: Yup.string().required('Last Name is required'),
    email: Yup.string().required('Email is required'),
  });

  const onSubmitHundler = (values, { setSubmitting, setErrors }) => {
    actions.update(
      dispatch,
      coach.id,
      values,
      () => {
        setSubmitting(false);
        closeEditCoach();
      },
      (errorData) => {
        const newErrors = {};
        errorData.errors.forEach((item) => {
          newErrors[item.source.pointer.replace('/data/attributes/', '')] = item.detail;
        });
        setErrors(newErrors);
        setSubmitting(false);
      },
    );
  };

  return (
    <Modal show>
      <Formik
        validationSchema={formSchema}
        initialValues={{
          firstName: coach.attributes.first_name,
          lastName: coach.attributes.last_name,
          email: coach.attributes.email,
        }}
        onSubmit={onSubmitHundler}
      >
        {({ isSubmitting }) => (
          <FormikForm className="needs-validation" noValidate="">
            <HorizontalTextField name="firstName" label="First Name" required />
            <HorizontalTextField name="lastName" label="Last Name" required />
            <HorizontalTextField name="email" type="email" label="Email" required />

            <footer>
              <Button
                variant="outline-primary"
                onClick={() => closeEditCoach()}
              >
                Cancel
              </Button>

              <Button
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Saving...' : 'Save'}
              </Button>
            </footer>
          </FormikForm>
        )}
      </Formik>
    </Modal>
  );
}

Index.propTypes = {
  coach: PropTypes.object.isRequired,
  closeEditCoach: PropTypes.func.isRequired,
};
